import styles from '../ServiceContractBillingOverlayController.module.scss';

import {
  CardHeader,
  RadioGroup,
  Stack,
  Theme,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Card } from '@work4all/components/lib/dataDisplay/card';
import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';

import { useUser } from '@work4all/data';

import { WartungsvertragPamentMethodSource } from '@work4all/models/lib/Enums/WartungsvertragPamentMethodSource.enum';

import { ControllerPlus } from '../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../form-plus/use-form-context-plus';
import { ControlWrapper } from '../../../components';
import { ServiceContractsBillingsFormValue } from '../types';

import { CheckboxItem, RadioItem } from './components/CheckboxItem';

export const CalculationAndPaymentTarget = () => {
  const { t } = useTranslation();
  const { control } = useFormContextPlus<ServiceContractsBillingsFormValue>();

  const user = useUser();
  const hasAdminRights = user.isMaster;

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <Card className={styles.card}>
      <CardHeader
        title={t('MASK.BILLING.CALCULATION_AND_PAYMENT_TARGET')}
        className={styles.cardHeader}
      />
      <ControlWrapper columns={isMobile ? 1 : 2} className={styles.cardContent}>
        <Stack>
          <Divider
            style={{ flex: '1', marginRight: '1rem' }}
            title={t('MASK.BILLING.CALCULATIONS')}
          />
          <ControllerPlus
            control={control}
            name="considerQuantity"
            render={({ field: { value: checked, ...field } }) => (
              <CheckboxItem
                label={t('MASK.BILLING.INPUTS.CONSIDER_QUANTITY')}
                checked={checked}
                disabled={!hasAdminRights}
                {...field}
              />
            )}
          />
          <ControllerPlus
            control={control}
            name="dividePriceByQuantity"
            render={({ field: { value: checked, ...field } }) => (
              <CheckboxItem
                label={t('MASK.BILLING.INPUTS.DIVIDE_PRICE_BY_QUANTITY')}
                checked={checked}
                disabled={!hasAdminRights}
                {...field}
              />
            )}
          />
          <ControllerPlus
            control={control}
            name="divideByRhythm"
            render={({ field: { value: checked, ...field } }) => (
              <CheckboxItem
                label={t('MASK.BILLING.INPUTS.DIVIDE_BY_RHYTHM')}
                checked={checked}
                disabled={!hasAdminRights}
                {...field}
              />
            )}
          />
          <ControllerPlus
            control={control}
            name="multiplyWithRhythm"
            render={({ field: { value: checked, ...field } }) => (
              <CheckboxItem
                label={t('MASK.BILLING.INPUTS.MULTIPLY_BY_RHYTHM')}
                checked={checked}
                disabled={!hasAdminRights}
                {...field}
              />
            )}
          />
          <ControllerPlus
            control={control}
            name="purchasePriceFromArticle"
            render={({ field: { value: checked, ...field } }) => (
              <CheckboxItem
                label={t('MASK.BILLING.INPUTS.PURCHASE_PRICE_FROM_ARTICLE')}
                checked={checked}
                disabled={!hasAdminRights}
                {...field}
              />
            )}
          />
        </Stack>
        <Stack>
          <Divider
            style={{ marginRight: '1rem' }}
            title={t('MASK.BILLING.PAYMENT_CONDITION')}
          />
          <ControllerPlus
            control={control}
            name="paymentTypeSource"
            render={({ field }) => (
              <ControlWrapper as={RadioGroup} className={styles.radioGroup}>
                <RadioItem
                  label={t('MASK.BILLING.INPUTS.PAYMENT_SOURCE.BASE_DATA')}
                  value={WartungsvertragPamentMethodSource.ADDRESS}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                  }}
                  checked={
                    field.value === WartungsvertragPamentMethodSource.ADDRESS
                  }
                  disabled={!hasAdminRights}
                />
                <RadioItem
                  label={t('MASK.BILLING.INPUTS.PAYMENT_SOURCE.CONTRACT')}
                  value={WartungsvertragPamentMethodSource.SERVICE_CONTRACT}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                  }}
                  checked={
                    field.value ===
                    WartungsvertragPamentMethodSource.SERVICE_CONTRACT
                  }
                  disabled={!hasAdminRights}
                />
              </ControlWrapper>
            )}
          />
        </Stack>
      </ControlWrapper>
    </Card>
  );
};
